import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eaacc84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icr-card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"icr-card__top\" data-v-2eaacc84><svg viewBox=\"0 0 24 24\" class=\"icr-card__icon\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-2eaacc84><path d=\"M9 12l2 2 4-4\" data-v-2eaacc84></path><path d=\"M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.66 0 3.22.45 4.56 1.24\" data-v-2eaacc84></path></svg><div class=\"icr-card__header\" data-v-2eaacc84><h2 class=\"icr-card__title\" data-v-2eaacc84>市场服务合同签署要求</h2><p class=\"icr-card__desc\" data-v-2eaacc84> 要求后，服务商在 <strong data-v-2eaacc84>提交结算</strong> 前必须先上传双方 <strong data-v-2eaacc84>线下签署</strong> 的合同扫描件，否则无法提交；上传完成后自动解除拦截。 </p></div></div>", 1)
const _hoisted_3 = { class: "icr-card__bottom" }
const _hoisted_4 = { class: "icr-card__summary" }
const _hoisted_5 = { class: "icr-card__summary--hl" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  class: "icr-card__btn-icon",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "9 18 15 12 9 6" })
], -1))
const _hoisted_7 = {
  key: 1,
  class: "icr-drawer"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "icr-drawer__title" }, "配置服务商合同要求"),
  /*#__PURE__*/_createElementVNode("p", { class: "icr-drawer__desc" }, " 对每家服务商单独设置是否要求上传线下签署合同；未设置默认为不要求。 ")
], -1))
const _hoisted_9 = { class: "icr-drawer__strategy" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icr-drawer__strategy-main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icr-drawer__strategy-head" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "0 0 24 24",
      class: "icr-drawer__strategy-icon",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12 2l7 4v6c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-4z" })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "icr-drawer__strategy-title" }, "新签约服务商默认策略")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "icr-drawer__strategy-desc" }, " 平台后续为本工业新绑定服务商时，系统按此默认值预置「是否要求上传合同」，免逐家补配、规避人工遗漏。仅作用于新入网服务商，不影响已有配置。 ")
], -1))
const _hoisted_11 = { class: "icr-drawer__strategy-toggle" }
const _hoisted_12 = { class: "icr-drawer__search" }
const _hoisted_13 = { class: "icr-drawer__batch" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icr-drawer__batch-label" }, "批量设置全部服务商", -1))
const _hoisted_15 = { class: "icr-drawer__batch-actions" }
const _hoisted_16 = { class: "icr-drawer__list" }
const _hoisted_17 = { class: "icr-drawer__footer" }
const _hoisted_18 = { class: "icr-drawer__pager" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  class: "icr-pager__icon",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "15 18 9 12 15 6" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "icr-pager__text" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  class: "icr-pager__icon",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "9 18 15 12 9 6" })
], -1))
const _hoisted_25 = [
  _hoisted_24
]

import { ref, computed, onMounted } from 'vue';
import {
  BaseButton,
  BaseSwitch,
  BaseInput,
  BaseTable,
  useTableColumn,
  XrkMessage
} from 'xrk-components';
import { queryContractReq, switchContractReq } from '../data-source/apis';

interface SpItem {
  finalDeptId: number;
  entpName: string;
  entpCertNo: string;
  isUploadContract: number;
}

const PAGE_SIZE = 8;


export default /*#__PURE__*/_defineComponent({
  __name: 'industry-contract-requirement-card',
  setup(__props) {

const drawerVisible = ref(false);
const searchKeyword = ref('');
const page = ref(1);
const list = ref<SpItem[]>([]);
const defaultRequired = ref(false);
const saving = ref(false);

const filteredList = computed(() => {
  const kw = searchKeyword.value.trim().toLowerCase();
  if (!kw) return list.value;
  return list.value.filter(
    sp =>
      sp.entpName.toLowerCase().includes(kw) ||
      sp.entpCertNo.toLowerCase().includes(kw)
  );
});

const filteredTotal = computed(() => filteredList.value.length);
const pageTotal = computed(() =>
  Math.max(1, Math.ceil(filteredTotal.value / PAGE_SIZE))
);

const pageList = computed(() => {
  const start = (page.value - 1) * PAGE_SIZE;
  return filteredList.value.slice(start, start + PAGE_SIZE);
});

const totalCount = ref(0);
const requiredCount = ref(0);

const tableColumns = [
  useTableColumn({ label: '服务商', prop: 'entpName', minWidth: 160 }),
  useTableColumn({
    label: '统一社会信用代码',
    prop: 'entpCertNo',
    minWidth: 180
  }),
  useTableColumn({
    label: '要求上传合同',
    prop: 'isUploadContract',
    width: 150,
    render: ({ row }) => (
      <div class="icr-toggle-row">
        <BaseSwitch
          v-model={row.isUploadContract}
          active-value={1}
          inactive-value={0}
          beforeChange={() => onToggleSp(row)}
        />
        <span
          class={
            row.isUploadContract
              ? 'icr-toggle-label--on'
              : 'icr-toggle-label--off'
          }
        >
          {row.isUploadContract ? '要求' : '不要求'}
        </span>
      </div>
    )
  })
];

const fetchData = async () => {
  const { data } = await queryContractReq();
  defaultRequired.value = !!data.signMarketContract;
  totalCount.value = data.totalServiceProviderCount || 0;
  requiredCount.value = data.requireUploadCount || 0;
  list.value = data.serviceProviderList || [];
};

onMounted(fetchData);

const refreshCounts = () => {
  requiredCount.value = list.value.filter(
    sp => sp.isUploadContract === 1
  ).length;
};

const openDrawer = () => {
  searchKeyword.value = '';
  page.value = 1;
  drawerVisible.value = true;
};

const closeDrawer = () => {
  drawerVisible.value = false;
};

const onSearch = () => {
  page.value = 1;
};

const onToggleSp = (sp: SpItem) => {
  const next = sp.isUploadContract === 1 ? 0 : 1;
  return new Promise<void>(async (resolve, reject) => {
    if (saving.value) return reject();
    saving.value = true;
    try {
      await switchContractReq({
        isUploadContract: next,
        aspId: sp.finalDeptId
      });
      refreshCounts();
      XrkMessage.success(
        next
          ? `已要求「${sp.entpName}」上传线下合同`
          : `已设为不要求「${sp.entpName}」上传合同`
      );
      resolve();
    } catch {
      reject();
    } finally {
      saving.value = false;
    }
  });
};

const onBatchSet = async (required: boolean) => {
  if (saving.value) return;
  saving.value = true;
  try {
    await switchContractReq({ isUploadContract: required ? 1 : 0 });
    list.value.forEach(sp => {
      sp.isUploadContract = required ? 1 : 0;
    });
    refreshCounts();
    XrkMessage.success(
      required
        ? '已要求全部服务商上传线下合同'
        : '已设为全部服务商不要求上传合同'
    );
  } finally {
    saving.value = false;
  }
};

const onToggleDefault = () => {
  const next = !defaultRequired.value;
  return new Promise<void>(async (resolve, reject) => {
    if (saving.value) return reject();
    saving.value = true;
    try {
      await switchContractReq({ signMarketContract: next ? 1 : 0 });
      XrkMessage.success(
        next
          ? '新签约服务商将默认要求上传合同'
          : '新签约服务商将默认不要求上传合同'
      );
      resolve();
    } catch {
      reject();
    } finally {
      saving.value = false;
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(" 共 "),
          _createElementVNode("strong", null, _toDisplayString(totalCount.value), 1),
          _createTextVNode(" 家服务商，其中 "),
          _createElementVNode("strong", _hoisted_5, _toDisplayString(requiredCount.value), 1),
          _createTextVNode(" 家要求上传 ")
        ]),
        _createVNode(_unref(BaseButton), {
          type: "primary",
          onClick: openDrawer
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 配置服务商要求 "),
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (drawerVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "icr-drawer-mask",
            onClick: _withModifiers(closeDrawer, ["self"])
          }))
        : _createCommentVNode("", true),
      (drawerVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", { class: "icr-drawer__header" }, [
              _hoisted_8,
              _createElementVNode("button", {
                class: "icr-drawer__close",
                onClick: closeDrawer
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(BaseSwitch), {
                  modelValue: defaultRequired.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultRequired).value = $event)),
                  "active-value": 1,
                  "inactive-value": 0,
                  beforeChange: onToggleDefault
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", {
                  class: _normalizeClass(
              defaultRequired.value
                ? 'icr-drawer__strategy-label--on'
                : 'icr-drawer__strategy-label--off'
            )
                }, _toDisplayString(defaultRequired.value ? '要求' : '不要求'), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(BaseInput), {
                modelValue: searchKeyword.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchKeyword).value = $event)),
                placeholder: "搜索服务商名称 / 统一社会信用代码",
                onKeyup: _withKeys(onSearch, ["enter"])
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(BaseButton), {
                  type: "default",
                  size: "small",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onBatchSet(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全部要求上传 ")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(BaseButton), {
                  type: "default",
                  size: "small",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (onBatchSet(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全部不要求 ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(BaseTable), {
                columns: tableColumns,
                data: pageList.value
              }, null, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, "共 " + _toDisplayString(filteredTotal.value) + " 家", 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  disabled: page.value <= 1,
                  class: "icr-pager__btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (page.value = page.value - 1))
                }, _hoisted_21, 8, _hoisted_19),
                _createElementVNode("span", _hoisted_22, _toDisplayString(page.value) + " / " + _toDisplayString(pageTotal.value), 1),
                _createElementVNode("button", {
                  disabled: page.value >= pageTotal.value,
                  class: "icr-pager__btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (page.value = page.value + 1))
                }, _hoisted_25, 8, _hoisted_23)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})